import React, { useState } from 'react'
import { WidgetContent, TextField, Toggle, Select } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import FormInputGroup from '../../UI/FormInputGroup'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import moment from 'moment'

const EditLoadModal = ({
  editLoad: saveEditedLoad,
  editLoadDetail,
  editLoadModalToggle,
  materialList,
  haulList
}) => {
  const editLoad = values => {
    const { _id } = editLoadDetail
    const haulValues = { ...values }
    if (loadHaul.quantity) haulValues.material = values.material.value
    saveEditedLoad(_id, haulValues)
    editLoadModalToggle()
  }

  const hanldeMaterialClick = (materialSelected, setFieldValue) => {
    setFieldValue('material', materialSelected)
    if (loadHaul.quantity.defaultMaterialQuantity) {
      updateLoadQuantity(materialSelected, setFieldValue)
    }
  }

  const updateLoadQuantity = (materialSelected, setFieldValue) => {
    const newMaterial = materialList.find(
      material => material.materialName === materialSelected.value
    )
    setUnit(newMaterial.unit)
    const truckKey = editLoadDetail.driver.trailerType
      ? editLoadDetail.driver.truckType
      : truckType()
    const trailerKey = editLoadDetail.driver.trailerType
      ? editLoadDetail.driver.trailerKey
      : trailerType()
    const newMaterialTruckVolume = newMaterial[truckKey]
    const newMaterialTrailerVolume = trailerKey && newMaterial[trailerKey]
    const totalLoadVolume = newMaterialTrailerVolume
      ? newMaterialTrailerVolume + newMaterialTruckVolume
      : newMaterialTruckVolume
    if (totalLoadVolume) return setFieldValue('quantity', totalLoadVolume)
  }

  const truckType = () => {
    const truckAndTrailerType = editLoadDetail.driver.truckType
    switch (true) {
      case /Single/.test(truckAndTrailerType):
        return 'singleTruck'
      case /Tandem/.test(truckAndTrailerType):
        return 'tandemTruck'
      case /End Dump/.test(truckAndTrailerType):
        return 'endDumpTruck'
      case /Tri-axle/.test(truckAndTrailerType):
        return 'triaxleTruck'
      default:
        return
    }
  }

  const trailerType = () => {
    const truckAndTrailerType = editLoadDetail.driver.truckType
    switch (true) {
      case /Tandem Pony/.test(truckAndTrailerType):
        return 'tandemPonyTrailer'
      case /Tri Pony/.test(truckAndTrailerType):
        return 'triPonyTrailer'
      case /3 Axle Transfer/.test(truckAndTrailerType):
        return 'threeAxleTransferTrailer'
      case /4 Axle Transfer/.test(truckAndTrailerType):
        return 'fourAxleTransferTrailer'
      case /Quad Trailer/.test(truckAndTrailerType):
        return 'quadTrailer'
      default:
        return
    }
  }

  const loadHaul = haulList.find(haul => haul.haulId === editLoadDetail.haulId)
  const initialMaterial = loadHaul.quantity
    ? materialList.find(material => material.materialName === editLoadDetail.material)
    : editLoadDetail.material
  const materialUnit = materialList.find(
    material => material.materialName === editLoadDetail.material
  )
  const [unit, setUnit] = useState(materialUnit && materialUnit.unit ? materialUnit.unit : '')

  return (
    <CreateNewModal
      title="Edit Load"
      bannerText="Press Save when finished making all changes"
      handleCloseModal={editLoadModalToggle}
    >
      <Formik
        initialValues={{
          arriveTimeA: editLoadDetail.arriveTimeA,
          arriveTimeB: editLoadDetail.arriveTimeB,
          material:
            loadHaul.quantity && materialUnit
              ? { value: initialMaterial.materialName }
              : editLoadDetail.material,
          quantity: editLoadDetail.quantity,
          materialConfirmed: editLoadDetail.materialConfirmed
        }}
        validationSchema={LoadSchema}
        handleSubmit={e => console.log(e)}
        onSubmit={values => {
          editLoad(values)
        }}
        render={({
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldTouched,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <WidgetContent style={{ height: '305px' }}>
              <FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div>
                    <TextField
                      className="halfWidthInputBox"
                      label="Pick Up Time"
                      name="pickUpTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={moment(values.arriveTimeA).format('HH:mm')}
                      maxLength={5}
                      disabled
                    />
                    <ErrorMessage
                      name="pickUpTime"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                  <div>
                    <TextField
                      className="halfWidthInputBox"
                      label="Drop Off Time"
                      name="dropOffTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={
                        values.arriveTimeB ? moment(values.arriveTimeB).format('HH:mm') : undefined
                      }
                      maxLength={5}
                      disabled
                    />
                    <ErrorMessage
                      name="dropOffTime"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div style={{ paddingTop: '16px' }}>
                    {loadHaul.quantity ? (
                      <Select
                        className="projecProvinceSelect optionsFullWidth"
                        activeOption={values.material}
                        label="Material"
                        options={materialList.map(material => {
                          return {
                            value: material.materialName
                          }
                        })}
                        menuPosition="bottom-left"
                        name="material"
                        onOptionClick={option => hanldeMaterialClick(option, setFieldValue)}
                        onBlur={() => setFieldTouched('material')}
                      />
                    ) : (
                      <TextField
                        className="halfWidthInputBox"
                        style={{ paddingRight: '16px' }}
                        label="Material"
                        name="material"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.material}
                      />
                    )}
                    <ErrorMessage
                      name="material"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                  <div style={{ paddingTop: '50px', paddingRight: '35px' }}>
                    <Toggle
                      defaultChecked={editLoadDetail.materialConfirmed}
                      label="Material Confirmed"
                      onChange={handleChange}
                      name="materialConfirmed"
                      value={values.materialConfirmed}
                      color="green"
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup horizontal>
                  <div style={{ paddingTop: '16px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      style={{ paddingRight: '16px' }}
                      label="Truck Volume"
                      name="quantity"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.quantity}
                      rightEl={unit}
                    />
                    <ErrorMessage
                      name="quantity"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
              </FormInputGroup>
            </WidgetContent>

            <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '83px' }}>
                <ModalButton buttonStyle="tertiary" name="Cancel" onClick={editLoadModalToggle} />
              </div>
              <div style={{ width: '83px' }}>
                <ModalButton success type="submit" disabled={isSubmitting} name="Save" />
              </div>
            </WidgetContent>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default EditLoadModal

const LoadSchema = Yup.object().shape({
  // pickUpTime: Yup.string()
  //   .required('Required')
  //   .min(5, 'Incorrect Time Format')
  //   // .max(5, 'Incorrect Time Format'),
  //   .matches(/^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/, 'Incorrect Time Format'),
  // dropOffTime: Yup.string()
  //   .required('Required')
  //   .min(5, 'Incorrect Time Format')
  //   // .max(5, 'Incorrect Time Format')
  //   .matches(/^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/, 'Incorrect Time Format'),
  material: Yup.string()
    .required('Required')
    .min(2, 'Too Short!')
    .max(20, 'Too Long!'),
  quantity: Yup.string()
    // .required('Required')
    .min(1, 'Too Short!')
    .max(10, 'Too Long!')
})
